<script setup lang="ts">
    // @ts-expect-error raison: lib externe mal typée
    import { ref, defineExpose } from 'vue';
    import MarketCheckoutAdresseFormModal from './MarketCheckoutAdresseFormModal.vue';

    const isModalOpen = ref(false);
    let promise: Promise<any>;
    let resolvePromise: any;
    let rejectPromise: any;
    const selectedAdresse = ref(null as any);
    const selectedAdresseId = ref(null as number | null);
    const adressesList = ref([] as any[]);
    const adresseFormModalRef = ref<InstanceType<typeof MarketCheckoutAdresseFormModal> | null>(null);

    async function open(adresses?: any) {
        promise = new Promise((resolve, reject) => {
            resolvePromise = resolve;
            rejectPromise = reject;
        });
        isModalOpen.value = true;
        adressesList.value = adresses || [];
        return await promise;
    }

    function onClose() {
        resolvePromise(null);
        isModalOpen.value = false;
    }

    async function onSubmit() {
        if (!selectedAdresseId.value) { return; }
        resolvePromise(selectedAdresse.value);
        isModalOpen.value = false;
    }

    function onAdresseSelected() {
        const adresse = adressesList.value.find(a => a.id === selectedAdresseId.value);
        selectedAdresse.value = adresse || null;
    }

    async function openAdresseFormModal(adresse?: any) {
        const adresseSaved = await adresseFormModalRef.value?.open(adresse);
        if (adresseSaved) {
            const index = adressesList.value.findIndex((a: any) => a.id === adresseSaved.id);
            if (index !== -1) {
                adressesList.value[index] = adresseSaved;
                adressesList.value = [...adressesList.value];
            } else {
                adressesList.value.push(adresseSaved);
            }
            selectedAdresseId.value = adresseSaved.id;
            onAdresseSelected();
        }
    }

    defineExpose({ open });
</script>
<template>
    
    <custom-modal v-model:show="isModalOpen" @closed="onClose">
        <template #header>
            <div style="flex: 1; display: flex; flex-direction:row; justify-content: space-between;">
                <h4 class="font-semibold">Adresses de livraison</h4>
            </div>
        </template>
        <div style="width: 500px; max-height: 500px; overflow: hidden; display: flex; flex-direction: column; justify-content: space-between;">            
            <button class="btn lg stroke w-100 flex-center" @click="openAdresseFormModal">
                <span>Ajouter une nouvelle adresse</span>
            </button>
            <div style="flex: 1; overflow: hidden; overflow-y: scroll;">
                <div class="card-check bg-white-50 widget flex my-2 pt-5 pb-4 px-6" :class="{'active': selectedAdresse?.id === adresse.id}" v-for="(adresse, index) of adressesList" :key="index">
                    <label class="s20" :for="'adresse_' + index">
                        <div class="s1 mt-1"><input class="" type="radio" :name="'super_' + index" :id="'adresse_' + index" :value="adresse.id" v-model="selectedAdresseId" @change="onAdresseSelected" /></div>
                        <h5 class="s16 pl-2 secondary-font">{{ adresse.libelle }} <br class="mb-2"/>
                            <span class="secondary-font text-grey-600">{{ adresse.adresse }} <br/>{{ adresse.telephone }}</span>
                        </h5>
                        <div class="s3 text-right">
                            <img src="/public/icons/icon-livraison-relais.svg" class="size-base" alt="" />
                        </div>
                    </label>
                </div>
            </div>
        </div>
        <template #footer>
            <button id="btn-confirmation-confirm" class="btn lg stroke" style="justify-content: center;" @click="onSubmit" :disabled="!selectedAdresseId">Valider</button>
            <button id="btn-confirmation-reject" class="btn lg white2" style="justify-content: center;" @click="onClose">Annuler</button>
        </template>
    </custom-modal>
    <market-checkout-adresse-form-modal ref="adresseFormModalRef"></market-checkout-adresse-form-modal>
</template>